import { useQueryClient } from '@tanstack/react-query';
import { useQueryMutation } from '../../api/use-query-mutation';
import { useBudgetId } from '../../budget/budget-store';
import { useApi } from '../../api/api-context';
import { logAndThrowError } from '../../utils/errors';
export const useDeleteAccountApi = (options) => {
    const api = useApi();
    const budgetId = useBudgetId();
    const queryKey = ['accounts', budgetId];
    const transactionsQueryKey = ['transactions', budgetId];
    const queryClient = useQueryClient();
    // API call
    const deleteAccountApi = async (data) => {
        const { budgetId, id } = data;
        await api.delete(`/account/${budgetId}/${id}`);
    };
    // Optimistic update
    const onMutate = (oldData, request) => {
        if (!oldData) {
            logAndThrowError('No accounts data found');
        }
        const accountToDelete = oldData.find((account) => account.id === request.id);
        if (!accountToDelete) {
            logAndThrowError('Account not found');
        }
        // Filter out the account to be deleted
        return oldData.filter((account) => account.id !== request.id);
    };
    // On success, invalidate the transactions query
    const onSuccess = async () => {
        queryClient.removeQueries({ queryKey: transactionsQueryKey });
    };
    return useQueryMutation(deleteAccountApi, queryKey, onMutate, {
        ...options,
        onSuccess: (...args) => {
            onSuccess();
            if (options?.onSuccess) {
                options.onSuccess(...args);
            }
        },
    });
};
